module.exports = __webpack_public_path__ + "img/black-and-white-pot.c171ea9d.png";